import React, { useEffect, useState } from "react"
import Select from "react-select"
import axios from "axios"
import MetaTags from "react-meta-tags"
import { showMessage } from "../../../components/Common/Toaster"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  CardText,
  Row,
  Input,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import get from "lodash/get"
//Date Picker
import "react-datepicker/dist/react-datepicker.css"
import "react-datetime/css/react-datetime.css"
import Datetime from "react-datetime"
import "assets/scss/datatables.scss"
import { getTokenFromLocalStorage } from "helpers/helpers"
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import {API_URL, sitename} from "../../../constants/constants"
import { getAccessExpiration, setAccessExpiration } from "helpers/repository"
import moment from "moment"
const AccessExpirationForm = props => {
  const [value, setValue] = useState("")
  const handleChange = d => {
    setValue(d)
  }
  const handleSubmit = e => {
    e.preventDefault()
    const format = "YYYY-MM-DD HH:mm:ss"
    const dateTime = moment(value).format(format)
    setAccessExpiration({ expires_at: dateTime }).then(res => {
      showMessage("success", res.data.message)
      props.history.push("/access-expiration")
    })
  }
  useEffect(() => {
    getAccessExpiration().then(res => {
      const defDate = new Date(res?.data?.data?.access_expiration?.expires_at)
      setValue(defDate)
    })
  }, [])
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Settings" breadcrumbItem="Access Expiration" />
          <Card style={{ minHeight: "500px" }}>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              This is the date the Operator Access will expire: date-input
            </h5>

            <CardBody>
              <CardText>
                This is the access to be set by SuperAdmin to revoke all access
                to console in the event the Operator does not pay their bill on
                time.
              </CardText>
              <Form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <label
                    htmlFor="example-datetime-local-input"
                    className="col-sm-3 col-form-label"
                  >
                    Expiration Date And Time
                  </label>
                  <Col sm={3}>
                    <Datetime
                      value={value}
                      initialValue={value}
                      onChange={d => handleChange(d)}
                      timeFormat={true}
                    />
                  </Col>
                </div>

                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="danger"
                          className="w-100"
                          onClick={e => {
                            setValue("")
                          }}
                        >
                          Reset
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(AccessExpirationForm)
